module.exports = __webpack_public_path__ + "static/media/1.0d5dfd3f.jpg";